import { LoadingOutlined } from "@ant-design/icons";
import classes from "../containers/styles/HomeContainer.module.css";
import { Row, Spin } from "antd";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { CarouselIndicator } from "components/Onboarding/Carousel";
import { useGetIdentity } from "@refinedev/core";
import { UserIdentityData } from "types/props";

export const Onboarding: React.FC = () => {
  const navigate = useNavigate();
  const { data: user } = useGetIdentity<UserIdentityData>();

  useEffect(() => {
    if (!user) {
      navigate("/login");
    }
  }, [user, navigate]);

  if (!user)
    return (
      <Row>
        <Row className={classes.HomeContainer} justify={"center"} align="middle">
          <Spin
            spinning={true}
            size="large"
            indicator={<LoadingOutlined style={{ fontSize: 48, color: "white" }} spin />}
          />
        </Row>
      </Row>
    );

  return (
    <>
      <CarouselIndicator />
    </>
  );
};
